import {Injectable} from '@angular/core';
import { Route, Router, UrlSegment } from '@angular/router';
import {KeycloakService} from 'keycloak-angular';
import {Observable} from 'rxjs';
import {Role} from '../../clm/types/role.enum';
import {EnvironmentService} from '../services/environment-service';

@Injectable({
  providedIn: 'root'
})
export class BrokerPortalGuard  {
  private readonly hasBrokerPortalAccess: boolean;
  private readonly rolesRequiredForBrokerPortal: string[] = [Role.Broker];
  userRoles: string[];

  constructor(
    private router: Router,
    private keycloakService: KeycloakService,
    private environmentService: EnvironmentService) {

    this.hasBrokerPortalAccess = this.environmentService.isAllowedToAccessBrokerPortal();
    this.userRoles = this.keycloakService.getUserRoles();
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    const hasExpectedRole: boolean = this.rolesRequiredForBrokerPortal.some((role: string) => this.userRoles.includes(role));

    if (!this.userRoles.length || !hasExpectedRole) {
      this.router.navigateByUrl('/');
      return false;
    }
    else if (!this.hasBrokerPortalAccess) {
      this.router.navigateByUrl('/');
      return false;
    }

    return true;
  }
}
